import { globalProps } from "neetocommons/initializers";
import useBreakpoints from "neetocommons/react-utils/useBreakpoints";
import { Dropdown as NeetoUIDropdown, Typography } from "neetoui";
import { useTranslation } from "react-i18next";

import CopyToClipboardButton from "components/CopyToClipboardButton";

import MenuItemButton from "./MenuButton";

import { MY_ORGANIZATION_URL } from "../../constants";

const { Menu, MenuItem } = NeetoUIDropdown;

const WorkspaceMenu = () => {
  const { t } = useTranslation();
  const { isSize } = useBreakpoints();

  const isMobile = isSize("mobile");

  return (
    <NeetoUIDropdown
      className="neeto-molecules-organization-menu-popup-wrapper"
      closeOnSelect={false}
      customTarget={<MenuItemButton />}
      interactiveDebounce={30}
      offset={[0, 5]}
      position={isMobile ? "bottom" : "right"}
      trigger="all"
      zIndex={99999}
    >
      <Menu>
        <MenuItem.Button
          data-testid="profile-organization-settings-button"
          href={MY_ORGANIZATION_URL}
          rel="noreferrer"
          target="_blank"
        >
          {t("neetoMolecules.sidebar.workspaceMenu.settings")}
        </MenuItem.Button>
        {globalProps.organization?.subdomain && (
          <MenuItem className="px-6 py-2">
            <span className="neeto-molecules-workspace-display__content flex flex-col gap-0.5 text-start">
              <Typography
                className="neeto-molecules-workspace-display__label"
                component="span"
                style="body2"
                weight="medium"
              >
                {t("neetoMolecules.sidebar.workspaceMenu.subdomain")}
              </Typography>
              <Typography
                className="neeto-molecules-workspace-display__name neeto-ui-text-gray-500 flex items-center gap-1"
                component="span"
                style="body3"
              >
                <span className="min-w-0 truncate">
                  {globalProps.organization.subdomain}
                </span>
                <CopyToClipboardButton
                  className="flex-shrink-0"
                  size="small"
                  style="text"
                  value={globalProps.organization.subdomain}
                />
              </Typography>
            </span>
          </MenuItem>
        )}
      </Menu>
    </NeetoUIDropdown>
  );
};

export default WorkspaceMenu;
